/**
 * Getting a generated PDF to the user.
 *
 * Desktop: open it in a new tab (unchanged behaviour).
 * Mobile: browsers (iOS especially) block window.open and navigator.share
 * once an `await` has consumed the tap's user activation, so the caller shows
 * a "PDF ready" sheet and calls sharePdf()/downloadPdf() from a fresh tap.
 */

export function canSharePdf(blob, filename) {
  try {
    const file = new File([blob], filename, { type: 'application/pdf' });
    return Boolean(navigator.canShare && navigator.canShare({ files: [file] }));
  } catch {
    return false;
  }
}

export function downloadPdf(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/** Opens the native share sheet; falls back to a download. Must run inside a tap handler. */
export async function sharePdf(blob, filename) {
  const file = new File([blob], filename, { type: 'application/pdf' });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: filename });
      return;
    } catch (err) {
      if (err.name === 'AbortError') return; // user closed the share sheet
      console.warn('Share failed, downloading instead:', err);
    }
  }
  downloadPdf(blob, filename);
}

export function openPdfInNewTab(blob) {
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
